import httpApiInternalAuth from "@/services/http/api-internal/auth";
import { useAuthStore } from "@/store/auth";

export default defineNuxtPlugin(({ $pinia, $apiDrive }) => {
  const authStore = useAuthStore($pinia);

  let accessToken = null;
  let accessTokenDate = null;
  const DIX_MINUTES = 1000 * 60 * 10;

  $apiDrive.setRequestInterceptor(async (config) => {
    if (authStore.isLogged) {
      config.headers.Authorization = `Bearer ${authStore.token}`;
    } else if (process.client && config.tokenClient) {
      if (!accessToken || !accessTokenDate || accessTokenDate.getTime() + DIX_MINUTES < Date.now()) {
        const { access_token } = await httpApiInternalAuth.tokenClient();
        accessToken = access_token;
        accessTokenDate = new Date();
      }
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  });
});
